export default function(params) {
  var self = ko.mapping.fromJS(params);

  self.logoBackgroundColor = ko.computed(function() {
    return 'background-color: ' + params.logo_background_color + ';';
  });

  self.dateAndAuthor = ko.computed(function() {
    if (params.formatted_publish_date) {
      return params.formatted_publish_date + ' | By ' + params.author;
    } else {
      return 'By ' + params.author;
    }
  });

  return self;
}